<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <router-link
                class="btn btn-sm btn-outline-info"
                :to="{ name: 'wms-tareas-manuales' }"
              >
                <i class="fas fa-angle-double-left"></i>
                Atras
              </router-link>
              <h5 class="form-header">
                Información de tarea #
                <u>{{ current.numero }}</u>
                <div class="st-meta float-right">
                  <br />
                  <button @click="refreshCurrent()" class="btn btn-md btn-info">
                    <i class="fas fa-sync"></i> Actualizar Info.
                  </button>
                  &nbsp;
                  <div class="element-actions">
                    <div class="btn-group">
                      <button
                        :disabled="!current.id"
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="btn btn-secondary dropdown-toggle"
                        data-toggle="dropdown"
                        type="button"
                      >
                        <i class="fa fa-cogs"></i>
                        Acciones
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <button
                          class="dropdown-item"
                          type="button"
                          :disabled="!(current.estado != '9')"
                          data-toggle="modal"
                          data-target="#modalAsignarUsuario"
                        >
                          <i class="fa fa-user"></i>
                          &nbsp; Asignar usuario
                        </button>
                        <div class="dropdown-divider"></div>
                        <button
                          class="dropdown-item"
                          type="button"
                          v-show="!current.fecha_asignacion"
                          @click="anularTarea(current)"
                        >
                          <i class="fa fa-trash"></i>
                          &nbsp; Anular Tarea
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </h5>
              <div class="row col-12">
                <div v-if="current.tienda_origen_obj" class="col-sm-2">
                  <label>Tienda origen</label>
                  <input
                    :disabled="true"
                    type="text"
                    class="form-control"
                    v-model="current.tienda_origen_obj.nombre"
                  />
                </div>
                <div v-if="current.tienda_origen_obj" class="col-sm-2">
                  <label>Tienda Destino</label>
                  <input
                    :disabled="true"
                    type="text"
                    class="form-control"
                    v-model="current.tienda_destino_obj.nombre"
                  />
                </div>
                <div class="col-sm-4">
                  <label>Fecha</label>
                  <input
                    v-model="current.fecha_creacion"
                    class="form-control"
                    placeholder="Fecha"
                    :disabled="true"
                    type="text"
                  />
                </div>

                <div class="col-sm-2">
                  <div class="form-group">
                    <label>Usuario creó</label>
                    <input
                      :disabled="true"
                      class="form-control"
                      v-model="current.usuario_crea.username"
                      type="text"
                    />
                  </div>
                </div>                         
                <div
                  class="col-sm-2"                        
                >
                  <div class="form-group">
                    <label>Usuario asignado </label>
                    <input
                      :disabled="true"
                      class="form-control"
                      v-model="current.usuario.username"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div>
                <br />
                <div class="col-12">
                  <button
                    :disabled="current.fecha_asignacion"
                    class="btn btn-secondary btn-block"
                    @click="abrirModalAsignarDetalle()"
                  >
                    <i class="fas fa-plus"></i> Agregar detalle a tarea
                  </button>
                </div>
              </div>
              <br />
              <div
                class="table-responsive invoice-table"
                v-if="current.id != null"
              >
                <table class="table table-striped table-hover" v-if="current.detalle.length>0">
                  <thead>
                    <tr>
                      <th>Producto</th>
                      <th class="text-right">Cant. solicitada</th>
                      <th class="text-right">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="detalle in current.detalle"
                      v-bind:key="detalle.id" v-show="detalle.estado!='9'" 
                    >                  
                      <td>
                        {{ detalle.producto}}
                      <!---producto --->
                        <br />
                        <small>{{ detalle.producto_obj.nombre }}</small>
                      </td>
                      <td
                        class="text-right bolder nowrap"
                        style="font-weight: 500"
                      >
                        <span>{{ detalle.cantidad_solicitada }}</span>
                      </td>
                      <td class="text-right" style="width: 150px">
                        <button class="btn btn-sm btn-danger mr-1" type="button" 
                          @click="deleteTareaDetalle(detalle)" v-if="!current.fecha_asignacion">
                          <i class="fa fa-minus"></i>
                          
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-------------------- END - Basic Table -------------------->
              </div>
              <div>
                <br />
                <div class="col-12">
                  <button                    
                    class="btn btn-success btn-block"
                    :disabled="current.fecha_asignacion"
                    @click="asignarUsuarioManual()"
                  >
                    <i class="fas fa-save"></i> Guardar tarea
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal asignar usuario-->
        <div
          class="modal fade"
          id="modalAsignarUsuario"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLongTitle"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">
                  Elige usuario
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">     
              <!-----------------V - SELECT --------------------------->
              <label class="text-">Usuario</label>
              <multiselect
                v-model="usuario_seleccionado"
                label="username"              
                :options="current_usuarios_pickeadores"
                placeholder="Selecciona un usuario"
                aria-label="Selecciona un usuario"
                trackBy="username"
              ></multiselect>
              &nbsp;&nbsp;
              <!------------------FIN DE V - SELECT ------------------->
              &nbsp;&nbsp;
              </div>
              <div class="modal-footer">              
                <button
                  @click="elegirUsuario(usuario_seleccionado)"
                  class="btn btn-success btn-lg"
                >
                  Aceptar <i class="fa fas-check"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
            <!-- Finaliza Modal asignar usuario-->
            <!-- Modal Eliminar Tarea -->
        <div
          class="modal fade"
          id="modalAnularTarea"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLongTitle"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">
                  Estas a punto de Eliminar toda la tarea
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <UsuariosSelectComponent :current="currentDetalle" />
              </div>
              <div class="modal-footer">
                <button
                  @click="asignarUsuarioManual()"
                  class="btn btn-danger btn-lg"
                >
                  Aceptar <i class="fa fas-check"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Finaliza Modal Eliminar Tarea-->
      </div>
    </div>
    <AsignarTareaModalComponent
      v-if = "current.tienda_destino_obj"
      :tarea="current"
      :reqs_pendientes="reqs_pendientes"
      @refreshCurrent="refreshCurrent()"
      :tienda_destino="current.tienda_destino_obj"
    />
  </div>
  
</template>

<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import SalidaTrasladoService from "@/services/inventario/SalidaTrasladoService";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import AsignarTareaModalComponent from "@/components/wms/tareas_manuales/AsignarTareaModalComponent";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import Multiselect from "vue-multiselect";
import UsuariosService from "@/services/accounts/UsuariosService"
import PaginationComponent from "@/components/utils/PaginationComponent";

export default {
  components: {
    ProductoSelectComponentV2,
    AsignarTareaModalComponent,
    UsuariosSelectComponent,
    Multiselect,
    PaginationComponent,
  },
  data() {
    return {
      reqs_pendientes: [],
      filter: {},
      currentDetalle: {
        estado:"",
        usuario: ""
      },
      current: {
        id: null,
        usuario: "",
        usuario_crea: "",
        estado_str: null,
        tienda_origen_obj: null,
        tienda_destino_obj: null,
        fecha: "",
        estado: "",
        tipo: "",
        errors: {
          tienda: "",
          fecha: "",
        },
      },
      // usuario_id:"",
      // nombre_usuario:"",
      usuario_seleccionado:"",      
      current_usuarios_pickeadores:[],   
    };
  },
  computed: {},
  mounted() {
    let self = this;
    
    
    if (this.$route.params.id) {
      self.refreshCurrent();      
    }

    if(this.$route.query.usuario_id!= null){      
      self.getUsuarioObjeto(this.$route.query.usuario_id)
      self.nombre_usuario = this.$route.query.nombre_usuario   
    }
    else{ 
      self.usuario_id = ""
      self.nombre_usuario = ""
      self.current_usuarios_pickeadores = []
      
    }    
  }, 
  methods: {
    asignarUsuarioManual() {     
      let self = this;            
      if (!self.hayProductosEnDetalle()) {   
        Notifications.alert.error(
          "Guardar Tarea",
          "Debe agregar detalle a la tarea"
        );
        return;    
      }else{
        console.log("verificando si hay usuario", self.current.usuario)
        if(!self.current.usuario){
          Notifications.alert.error(
          "Asignar Usuario",
          "No hay un usuario asignado, debe seleccionar un usuario desde Acciones"
        );
        return;
          
        }else{   
          Notifications.alert.confirm(
            "Guardar Tarea",
            "¿Esta seguro?",
            "Si",
            function () {
              console.log("AGREGANDO NUEVO USUARIO")
              DynamicService.postAction(
                "wms",
                "tareas",
                self.current.id,
                "asignar_usuario", 
                self.current.usuario
              )
                .then((response) => {
                  self.refreshCurrent();               
                  Notifications.alert.success(
                    "Guardar Tarea",
                    "Realizado Exitosamente"
                  );
                  //$("#modalAsignarUsuario").modal("hide");
                })
                .catch((error) => {         
                  Notifications.alert.error(
                    "Guardar Tarea",
                    error.response.data.detail
                  );

                });
            })        
        }   
      }
    },
    abrirModalAsignarDetalle() {
      let self = this;
      $("#ModalAggDetalleSolicitud").modal("show");
    },
    refreshRequisicionesPendientes() {
      let self = this;
      self.filter.tienda_origen = self.current.tienda_origen;
      self.filter.tienda_destino = self.current.tienda_destino;
      DynamicService.getActionList(
        "wms",
        "tareas",
        "obtener_reqs_para_tarea_manual",
        self.filter
      ).then((response) => {
        self.reqs_pendientes = response.data;
      });
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById("wms", "tareas", self.$route.params.id)
        .then((res) => {           
          self.current = {}       
          self.current = res.data;        
          self.current.fecha_creacion = self.customFormatter(
            self.current.fecha_creacion
          );    
          self.getUsuariosPickeadores();           
        })
        .catch((err) => {});
      },
      customFormatter(date) {
      return moment(date).format("DD/MM/YYYY hh:mm:s a");
    },
    deleteTareaDetalle(detalle) {
      let self = this;     
     
      Notifications.alert.confirm_danger(
        "Detalle de Tarea",
        "El producto seleccionado se quitará de la tarea actual y quedará disponible para asignarlo a otra tarea",
        "Si Eliminar",
        function () {
          DynamicService.postAction(
            "wms",
            "tareas",
            self.current.id,
            "eliminar_detalle_tarea",
            detalle,
          )
            .then((response) => {
              Notifications.alert.success(
                "Detalle de Tarea",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;

              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Detalle de tarea",
                  error.response.data.detail
                );
              } else {
                if (error.response.data.salida_traslado_d) {
                  Notifications.alert.error(
                    "Detalle de tarea",
                    error.response.data.salida_traslado_d
                  );
                }
              }
            });
        }
      );
    },
    anularTarea(current) {
      let self = this;          
      Notifications.alert.confirm_danger(
        "Anular Tarea",
        "Estas a punto de anular la tarea completa, todos los productos en el detalle volverán a quedar disponibles para asignarlos nuevamente en otras tareas",
        "Si Eliminar",
        function () {
          DynamicService.postAction(
            "wms",
            "tareas",
            self.current.id,
            "anular_tarea_manual",
            self.current,
          )
            .then((response) => {
              Notifications.alert.success(
                "Detalle de Tarea",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();

              //Redireccionar a la lista de Tareas
              self.$router.push({
                name: "wms-tareas-manuales",
                params: {},
              });
            })
            .catch((error) => {
              self.current.errors = error.response.data;

              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Detalle de tarea",
                  error.response.data.detail
                );
              } else {
                if (error.response.data.salida_traslado_d) {
                  Notifications.alert.error(
                    "Detalle de tarea",
                    error.response.data.salida_traslado_d
                  );
                }
              }
            });
        }
      );
    },
    getUsuariosPickeadores(){    
      let self = this;
      
      DynamicService.getActionList("wms", "tareas", "get_usuarios_pickeadores","")
       .then((res) => {      
        // self.current.usuarios_tienda = []
        self.current_usuarios_pickeadores = res.data;              
        })
       .catch((err) => {
          Notifications.alert.error(
            "Obtener Pickeadores",
            error.response.data.detail
          )
        });
    },
    elegirUsuario(usuario_seleccionado){
      let self = this; 
      self.current.usuario = usuario_seleccionado      
      let params = {
        usuario : self.current.usuario,
        id: self.current.id
      }

      DynamicService.postActionList("wms", "tareas", "actualizar_usuario", params )
      .then((response) =>{      
        Notifications.alert.success(
          "Asignación de usuario",
          "El usuario ha sido asignado exitosamente"
        )  
        self.refreshCurrent()
      }).catch((error)=> {
        Notifications.alert.error(
          "Reasignar Usuario",
          error.response.data.detail
        )
      })               
      $("#modalAsignarUsuario").modal("hide");
    },

    getUsuarioObjeto(id_usuario){
      let self=this;     
      
      UsuariosService.getById(id_usuario).then((response)=>{     
        self.currentDetalle.estado = "A";
        self.currentDetalle.usuario = response.data
      })      
    },
    hayProductosEnDetalle(){     
      let self = this;
      let existenProductosEnDetalle = self.current.detalle.some(c => c.estado === "A");     
      return existenProductosEnDetalle;
    }
  },
};
</script>
